import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line func-names
const SkipLinks = function (props) {
  const { mainNavId, mainContentId } = props;
  const SkipLinksCSS = `
  .umnHeaderSkipLinksWrapperDiv {
    position: absolute;
    top: 0;
    left: -10000px;
    width: 1px;
    height: 1px;
    overflow: hidden;
    padding: 15px;
    background: #fff;
    border-radius: 0 0 5px 5px;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.5);
  }
  
  .umnHeaderSkipLinksWrapperDiv:focus-within {
    left: 0;
    width: auto;
    height: auto;
    overflow: auto;
  }
  
  .umnHeaderSkipLinksUl {
    margin: 0;
    padding: 0;
  }
  
  .umnHeaderSkipLinksLi {
    display: inline-block;
    margin-right: 15px;
  }
  
  `;

  if (mainNavId || mainContentId) {
    return (
      <div
        className='headerLinks umnHeaderSkipLinksWrapperDiv'
        id=' umnHeaderSkipLinks'
      >
        <style
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: SkipLinksCSS,
          }}
        />
        <ul className='umnHeaderSkipLinksUl'>
          {mainNavId && (
            <li className='umnHeaderSkipLinksLi'>
              <a href={`#${mainNavId}`}>Main navigation</a>
            </li>
          )}
          {mainContentId && (
            <li className='umnHeaderSkipLinksLi'>
              <a href={`#${mainContentId}`}>Main content</a>
            </li>
          )}
        </ul>
      </div>
    );
  }
  return '';
};

SkipLinks.propTypes = {
  mainNavId: PropTypes.string.isRequired,
  mainContentId: PropTypes.string.isRequired,
};

export default SkipLinks;
